<script setup lang="ts">
import type { DropdownMenuProps, DropdownMenuSlots } from '@nuxt/ui';
import type { ButtonProps } from '#layers/ui/components/Button.vue';
import { omit } from '#layers/base/public';
import DButton from '#layers/ui/components/Button.vue';
import { mergeUi } from '#layers/ui/utils/merge-ui';
import DDropdownMenu from '#ui/components/DropdownMenu.vue';

defineOptions({
	name: 'OverflowMenu',
});

defineProps<{
	items: DropdownMenuProps['items'];
	triggerUi?: ButtonProps['ui'];
	trigger?: Omit<ButtonProps, 'ui'> & Record<string, any>;
	ui?: DropdownMenuProps['ui'];
	disabled?: boolean;
}>();

const slots = defineSlots<DropdownMenuSlots>();
const getProxySlots = () => omit(slots, ['default']);
</script>

<template>
	<DDropdownMenu :items :disabled :ui>
		<template #default="{ open }">
			<slot :open>
				<DButton
					color="neutral"
					variant="ghost"
					square
					icon="lucide:ellipsis"
					class="text-muted hover:text-highlighted focus-visible:text-highlighted"
					:class="{
						'bg-elevated': open,
					}"
					:ui="mergeUi({ leadingIcon: 'size-4' }, triggerUi)"
					:aria-label="$t('common.open_menu')"
					data-testid="overflow-menu"
					v-bind="trigger"
					@click.stop
				/>
			</slot>
		</template>

		<template v-for="(_, name) in getProxySlots()" #[name]="slotData: any">
			<slot :name v-bind="slotData" />
		</template>
	</DDropdownMenu>
</template>
